import { ScanWalletAddress } from 'BreetComponents';
import { useWithdrawUsdRequestContext } from 'BreetHooks';
import { useCallback } from 'react';

import { useWithdrawRequestUsdFormStageContext } from '../FormStageContext';

const DialogWithdrawUsdScanWalletAddress = () => {
	const { navigator } = useWithdrawRequestUsdFormStageContext();
	const { formDataContextProps } = useWithdrawUsdRequestContext();

	const { setValueAndValidate } = formDataContextProps;

	const handleClose = useCallback(() => {
		navigator.reset();
		navigator.goTo('withdraw-funds')();
	}, [navigator]);

	const handleScannedAddress = useCallback(
		async (address: string) => {
			await setValueAndValidate('receiverAddress', address);
			handleClose();
		},
		[setValueAndValidate, handleClose]
	);

	return (
		<ScanWalletAddress
			handleClose={handleClose}
			validateAddress={handleScannedAddress}
		/>
	);
};

export default DialogWithdrawUsdScanWalletAddress;
